<template>
  <div class="flex justify-between items-end x-sm:!flex-wrap x-sm:gap-[10px]">
    <v-tabs v-model="currentTab" show-arrows class="cfs-tabs" v-bind="$attrs" v-on="$listeners">
      <v-tab
        v-for="tab in tabs"
        :key="tab.value"
        :href="`#${tab.value}`"
        :disabled="isDisabledTab(tab.value)"
      >
        {{ $t(tab.text) }}
      </v-tab>
    </v-tabs>

    <slot name="right" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    tabs: {
      type: Array as PropType<{ value: string; text: string }[]>,
      default: () => [],
    },
    isDisabledTab: {
      type: Function,
      default: () => false,
    },
    value: {
      type: String,
      default: '',
    },
    showArrows: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const currentTab = computed({
      get: () => props.value,
      set: (value) => emit('input', value),
    });
    return { currentTab };
  },
});
</script>
<style scoped lang="scss">
.cfs-tabs {
  ::v-deep {
    .v-tabs-bar {
      background-color: transparent !important;
    }
    .v-tab {
      padding: 0 1rem;
    }

    .v-slide-group__next,
    .v-slide-group__prev {
      min-width: 1.5rem !important;
    }
  }
}
</style>
